// extracted by mini-css-extract-plugin
export var hidden = "_48-1";
export var leftPanel = "_48-2";
export var readonlyInspector = "_48-3";
export var rightPanel = "_48-0";